import { useState } from "react";
import API from "../../services/api";

function PlantTimeline({ timelineTecnica = [], sectionTitleStyle }) {


  const [storiaAperta, setStoriaAperta] = useState(true);
  const [timelineFilter, setTimelineFilter] = useState("all");
  const [searchTimeline, setSearchTimeline] = useState("");

  const getEventConfig = (tipo) => {
    const type = (tipo || "").toLowerCase();

    if (type.includes("intervento")) {
      return {
        label: "Intervento tecnico",
        color: "#16a34a",
        background: "#dcfce7",
        text: "#166534",
        icon: "🔧",
        description: "Lavoro o controllo eseguito sull’impianto",
      };
    }

    if (type.includes("manutenzione")) {
      return {
        label: "Manutenzione",
        color: "#d97706",
        background: "#fef3c7",
        text: "#92400e",
        icon: "🛠️",
        description: "Attività programmata per mantenere l’impianto efficiente",
      };
    }

    if (type.includes("scadenza")) {
      return {
        label: "Verifica tecnica",
        color: "#dc2626",
        background: "#fee2e2",
        text: "#991b1b",
        icon: "⚠️",
        description: "Controllo, verifica o adempimento da monitorare",
      };
    }

    if (type.includes("documento")) {
      return {
        label: "Documento",
        color: "#2563eb",
        background: "#dbeafe",
        text: "#1e40af",
        icon: "📄",
        description: "File o allegato collegato all’impianto",
      };
    }

    return {
      label: "Evento impianto",
      color: "#0f3c75",
      background: "#e2e8f0",
      text: "#334155",
      icon: "•",
      description: "Informazione registrata nella storia dell’impianto",
    };
  };

  const formatDate = (value) => {
    if (!value) return "Data non disponibile";
    return new Date(value).toLocaleDateString("it-IT");
  };

  const isDocumentEvent = (item) =>
    (item.tipo || "").toLowerCase().includes("documento");

  const isUploadPath = (text) => {
    if (!text) return false;
    return String(text).includes("uploads/");
  };

  const getFileUrl = (path) => {
    if (!path) return null;
    if (String(path).startsWith("http")) return path;

    const normalizedPath = String(path).replaceAll("\\", "/");

    if (!normalizedPath.includes("uploads/")) return null;

    return `${API}/${normalizedPath}`;
  };

  const getCleanDescription = (item) => {
    if (!isDocumentEvent(item)) {
      return item.descrizione || "Nessun dettaglio aggiuntivo inserito.";
    }

    return "";
  };

  const matchesFilter = (item, filter) => {
    const tipo = (item.tipo || "").toLowerCase();

    if (filter === "all") return true;
    if (filter === "interventi") return tipo.includes("intervento");
    if (filter === "manutenzioni") return tipo.includes("manutenzione");
    if (filter === "verifiche") return tipo.includes("scadenza");
    if (filter === "documenti") return tipo.includes("documento");

    return true;
  };

  const matchesSearch = (item) => {
    const search = searchTimeline.trim().toLowerCase();

    if (!search) return true;

    return (
      item.titolo?.toLowerCase().includes(search) ||
      item.descrizione?.toLowerCase().includes(search) ||
      item.tipo?.toLowerCase().includes(search) ||
      formatDate(item.data).toLowerCase().includes(search)
    );
  };

  const filteredTimeline = timelineTecnica.filter(
    (item) => matchesFilter(item, timelineFilter) && matchesSearch(item)
  );

  const groupedTimeline = filteredTimeline.reduce((groups, item) => {
    const dateKey = formatDate(item.data);

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }

    groups[dateKey].push(item);
    return groups;
  }, {});

  const getFilterCount = (filter) =>
    timelineTecnica.filter(
      (item) => matchesFilter(item, filter) && matchesSearch(item)
    ).length;

  const resetFilters = () => {
    setTimelineFilter("all");
    setSearchTimeline("");
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "14px",
        padding: "22px",
        border: "1px solid #dbe4f0",
        boxShadow: "0 2px 8px rgba(15,60,117,0.06)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
          marginBottom: "6px",
        }}
      >
        <h2 style={sectionTitleStyle}>
          Storia dell’impianto ({timelineTecnica.length})
        </h2>

        <button
          type="button"
          onClick={() => setStoriaAperta(!storiaAperta)}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#dbeafe";
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(15,60,117,0.12)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#f1f5f9";
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
          style={{
            border: "1px solid #dbe4f0",
            background: "#f1f5f9",
            color: "#0f3c75",
            borderRadius: "8px",
            padding: "8px 14px",
            cursor: "pointer",
            fontWeight: 700,
            fontSize: "14px",
            transition: "all 0.2s ease",
          }}
        >
          {storiaAperta ? "▲ Chiudi" : "▼ Apri"}
        </button>
      </div>

      {storiaAperta && (
        <>
          <p
            style={{
              color: "#64748b",
              fontSize: "14px",
              marginTop: "6px",
              marginBottom: 0,
              lineHeight: "1.5",
            }}
          >
            Cronologia completa dell’impianto: interventi, manutenzioni,
            verifiche tecniche e documenti caricati, dal più recente al più
            vecchio.
          </p>

          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              marginTop: "16px",
            }}
          >
            <input
              type="text"
              placeholder="Cerca nella storia impianto..."
              value={searchTimeline}
              onChange={(e) => setSearchTimeline(e.target.value)}
              style={{
                flex: 1,
                padding: "11px 13px",
                border: "1px solid #cbd5e1",
                borderRadius: "10px",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            {(searchTimeline || timelineFilter !== "all") && (
              <button
                type="button"
                onClick={resetFilters}
                style={{
                  border: "1px solid #dbe4f0",
                  background: "#f8fafc",
                  color: "#0f3c75",
                  borderRadius: "10px",
                  padding: "10px 13px",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: "13px",
                }}
              >
                Azzera
              </button>
            )}
          </div>

          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              marginTop: "14px",
            }}
          >
            {[
              ["all", "Tutti"],
              ["interventi", "Interventi"],
              ["manutenzioni", "Manutenzioni"],
              ["verifiche", "Verifiche"],
              ["documenti", "Documenti"],
            ].map(([value, label]) => (
              <button
                key={value}
                type="button"
                onClick={() => setTimelineFilter(value)}
                onMouseEnter={(e) => {
                  if (timelineFilter !== value) {
                    e.currentTarget.style.background = "#dbeafe";
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(15,60,117,0.12)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (timelineFilter !== value) {
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }
                }}
                style={{
                  border: "1px solid #dbe4f0",
                  borderRadius: "999px",
                  padding: "7px 12px",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: "12px",
                  transition: "all 0.2s ease",
                  background: timelineFilter === value ? "#dbeafe" : "#ffffff",
                  color: timelineFilter === value ? "#1e40af" : "#334155",
                  boxShadow:
                    timelineFilter === value
                      ? "0 2px 6px rgba(15,60,117,0.10)"
                      : "none",
                }}
              >
                {label} ({getFilterCount(value)})
              </button>
            ))}
          </div>

          {filteredTimeline.length !== timelineTecnica.length && (
            <div
              style={{
                marginTop: "12px",
                color: "#64748b",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              Visualizzati {filteredTimeline.length} eventi su{" "}
              {timelineTecnica.length}.
            </div>
          )}

          {filteredTimeline.length === 0 ? (
            <div
              style={{
                marginTop: "14px",
                border: "1px solid #dbe4f0",
                borderRadius: "12px",
                padding: "16px",
                backgroundColor: "#f8fbff",
                color: "#4b5563",
              }}
            >
              Nessuna attività trovata per il filtro o la ricerca selezionata.
            </div>
          ) : (
            <div
              style={{
                marginTop: "20px",
                maxHeight: "560px",
                overflowY: "auto",
                paddingRight: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "22px",
              }}
            >
              {Object.entries(groupedTimeline).map(([date, items]) => (
                <div key={date}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      style={{
                        color: "#173a63",
                        fontSize: "15px",
                        fontWeight: 800,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {date}
                    </div>

                    <div
                      style={{
                        height: "1px",
                        background: "#dbe4f0",
                        flex: 1,
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {items.map((item) => {
                      const config = getEventConfig(item.tipo);
                      const fileUrl = isDocumentEvent(item)
                        ? getFileUrl(item.descrizione)
                        : null;

                      return (
                        <div
                          key={item.id}
                          onClick={() => {
                            if (fileUrl) {
                              window.open(fileUrl, "_blank", "noreferrer");
                            }
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-1px)";
                            e.currentTarget.style.boxShadow =
                              "0 6px 16px rgba(15,60,117,0.10)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          style={{
                            borderLeft: `4px solid ${config.color}`,
                            paddingLeft: "16px",
                            background: "#f8fbff",
                            borderRadius: "0 12px 12px 0",
                            paddingTop: "12px",
                            paddingBottom: "12px",
                            paddingRight: "14px",
                            cursor: fileUrl ? "pointer" : "default",
                            transition: "all 0.18s ease",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <span>{config.icon}</span>

                            <span
                              style={{
                                background: config.background,
                                color: config.text,
                                borderRadius: "999px",
                                padding: "4px 9px",
                                fontSize: "12px",
                                fontWeight: 800,
                              }}
                            >
                              {config.label}
                            </span>

                            <span
                              style={{
                                color: "#64748b",
                                fontSize: "12px",
                              }}
                            >
                              {config.description}
                            </span>
                          </div>

                          <div
                            style={{
                              color: "#173a63",
                              fontWeight: 800,
                              fontSize: "15px",
                              marginBottom: "6px",
                            }}
                          >
                            {item.titolo || "Attività registrata"}
                          </div>

                          {getCleanDescription(item) && (
                            <div
                              style={{
                                color: "#4b5563",
                                lineHeight: "1.5",
                                fontSize: "14px",
                              }}
                            >
                              {getCleanDescription(item)}
                            </div>
                          )}

                          {fileUrl && (
                            <div style={{ marginTop: "10px" }}>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-secondary"
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                  display: "inline-flex",
                                  background: "#e2e8f0",
                                  color: "#0f3c75",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  fontWeight: 700,
                                  textDecoration: "none",
                                  fontSize: "13px",
                                }}
                              >
                                Apri documento
                              </a>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default PlantTimeline;